// extracted by mini-css-extract-plugin
module.exports = {"alert-content":"styles-module__alert-content___1QYf5"};